import { render, staticRenderFns } from "./input-font.vue?vue&type=template&id=cd39c06e&scoped=true"
import script from "./input-font.vue?vue&type=script&lang=js"
export * from "./input-font.vue?vue&type=script&lang=js"
import style0 from "./input-font.vue?vue&type=style&index=0&id=cd39c06e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd39c06e",
  null
  
)

export default component.exports